import type { participation as en } from '@/i18n/locales/en/participation';
import type { Translation } from '@/i18n/types';

export const participation: Translation<typeof en> = {
  page: {
    title: 'Teilnahme',
    lead: 'Der Engagement-Funnel: von eingeladen bis strukturell aktiv, plus tägliche Engagement-Raten.',
    noScope: 'Wählen Sie ein Unternehmen, um die Teilnahmezahlen zu sehen.',
    noDepartments: 'Keine Abteilung hier hat Statistiken, die Sie sehen dürfen.',
    disclaimer:
      'Alle Werte sind indikative Wohlbefindens-Einblicke und keine medizinische Diagnose. Trends werden nur bei ausreichend vielen Teilnehmenden angezeigt (Privacy by Design).',
  },
  filters: {
    department: {
      label: 'Abteilung',
    },
    location: {
      label: 'Standort',
      all: 'Alle Standorte',
    },
  },
  funnel: {
    title: 'Engagement-Funnel',
    pctOfPrevious: '{{pct}}% des vorherigen Schritts',
    steps: {
      invited: 'Eingeladen',
      activated: 'Aktiviert',
      active_7d: 'Aktiv (7T)',
      active_30d: 'Aktiv (30T)',
      structurally_active: 'Strukturell aktiv',
      needs_reactivation: 'Reaktivierung nötig',
    },
  },
  rates: {
    title: 'Engagement-Raten',
    keys: {
      daily_sync_pct: 'Tägliche Synchronisation',
      ai_coach_use_pct: 'KI-Coach-Nutzung',
      challenge_participation_pct: 'Challenge-Teilnahme',
      notification_open_pct: 'Benachrichtigungsöffnungen',
      break_adoption_pct: 'Pausen-Adoption',
      focus_rhythm_pct: 'Fokusrhythmus',
    },
  },
  breakdown: {
    department: 'Nach Abteilung',
    location: 'Nach Standort',
    pilotGroup: 'Nach Pilotgruppe',
    empty: 'Noch keine Daten zur Aufschlüsselung.',
    pilotGroupEmpty: 'Noch keine Pilotgruppe deckt diese Abteilung ab.',
    ratio: '{{activated}}/{{invited}} · {{pct}}%',
    shielded: {
      badge: 'Geschützt',
      message:
        'Nicht genug Teilnehmende ({{invited}}) für eine datenschutzsichere Ansicht — mindestens {{min}} erforderlich.',
    },
    columns: {
      name: 'Name',
      invited: 'Eingeladen',
      activated: 'Aktiviert',
      active30d: 'Aktiv (30T)',
    },
  },
  status: {
    noData: '—',
  },
};
